import React from 'react';

const ExperienceFooter = ({ visible, titleText, bodyText, contactText, onContact }) => {
  if (!visible) {
    return null;
  }

  return (
    <footer className="footer-contact experience-footer">
      <div className="inner experience-footer__inner">
        <h2 className="experience-footer__title">{titleText}</h2>
        <p className="experience-footer__text">{bodyText}</p>
        <p className="experience-footer__action">
          <button className="btn fit experience-footer__button" onClick={onContact}>
            <span className="text experience-footer__button-text">{contactText}</span>
          </button>
        </p>
      </div>
    </footer>
  );
};

export default ExperienceFooter;
